import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Select, Store } from '@ngxs/store';
import * as FileSaver from 'file-saver';
import * as moment from 'moment';
import { ConfirmationService } from 'primeng/api';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { combineLatest, Observable } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { ConfirmSignaturePayload } from '../../../../interfaces/idefend/confirm-signature-payload.interface';
import { PolicyCreatorService } from '../../policy-creator/policy-creator.service';
import { SignOffer } from '../../policy-creator/store/offer.action';
import { OfferState } from '../../policy-creator/store/offer.state';
import { CreationLockResponse } from '../../shared/interfaces/creation-lock-response.interface';
import { WarrantyOfferState } from '../../warranty-creator/store/warranty-offer.state';

@Component({
  selector: 'app-apk-sign-policy-dialog',
  templateUrl: './apk-sign-policy-dialog.component.html',
  styleUrls: ['./apk-sign-policy-dialog.component.scss'],
  providers: [DialogService, ConfirmationService],
})
export class ApkSignPolicyDialogComponent implements OnInit {
  form: UntypedFormGroup;
  @Select(OfferState.offerLocked)
  offerLocked$: Observable<CreationLockResponse>;
  @Select(WarrantyOfferState.warrantyOfferLocked)
  warrantyOfferLocked$: Observable<CreationLockResponse>;
  isWarrantyGap: boolean;
  loading = false;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private fb: UntypedFormBuilder,
    private store: Store,
    private policyCreatorService: PolicyCreatorService,
  ) {}

  ngOnInit(): void {
    combineLatest([this.offerLocked$, this.warrantyOfferLocked$])
      .pipe(takeUntil(this.ref.onClose))
      .subscribe(([offerLocked, warrantyOfferLocked]) => {
        const productCode =
          offerLocked?.productCode || warrantyOfferLocked?.productCode;
        this.isWarrantyGap = productCode.includes('5_CP_');
      });

    this.form = this.fb.group({
      code: [null, [Validators.required]],
    });
  }

  signPolicy(): void {
    const payloadDto: ConfirmSignaturePayload = {
      confirmationCode: this.form.get('code').value,
      confirmedOn: moment().format('YYYY-MM-DDTHH:mm:ssZ'),
    };

    this.store
      .dispatch(new SignOffer(this.config.data.offerLocked.id, payloadDto))
      .pipe(take(1))
      .subscribe(() => {
        this.ref.close();
      });
  }

  getAttachments() {
    const documentType = 'POLICY_PRECONTRACT';
    this.policyCreatorService
      .getAttachments(this.config.data.offerLocked.id, documentType)
      .pipe(take(1))
      .subscribe((res) => {
        const file = new Blob([new Uint8Array(res.data)], {
          type: 'application/pdf;charset=utf-8',
        });
        FileSaver.saveAs(file, `${this.config.data.offerLocked.number}.pdf`);
      });
  }

  handleDialogClose(): void {
    this.ref.close();
  }
}
